import React from "react";
import { uploadIntroductionTemplate } from "./actions";
import AddAdditionalDocumentModal from "features/AdditionalDocuments/AddAdditionalDocumentModal";

const AddIntroductionTemplateModal = ({ onSubmitted, dealerId, ...props }) => (
  <AddAdditionalDocumentModal
    {...props}
    submitAction={uploadIntroductionTemplate}
    triggerText="Upload New Introduction Template"
    headerText="New Introduction Template"
    onSubmitted={onSubmitted}
    dealerId={dealerId}
  />
);

export default AddIntroductionTemplateModal;
